import React from 'react';
import AnimatedSection from '../ui/AnimatedSection';
import AnimatedCard from '../ui/AnimatedCard';

const Team = () => {
  const teamMembers = [
    {
      image: "./img/team/ramesh.jpg.jpg",
      name: "Ramesh",
      position: "Founder"
    },
    {
      image: "./img/team/team-2.jpg",
      name: "Satish Jantli",
      position: "CEO"
    },
    {
      image: "./img/team/team-1.jpg",
      name: "Ramnath Sah",
      position: "Director"
    },
    {
      image: "./img/team/manali.jpg.jpg",
      name: "Manali",
      position: "Director"
    },
    {
      image: "./img/team/team-4.jpg",
      name: "Sneha",
      position: "HR Director"
    }
  ];

  return (
    <section id="team" className="py-20 dark-section relative">
      <div className="container mx-auto px-4 relative z-10">
        <AnimatedSection>
          <div className="text-center mb-8">
            <h2 className="text-sm font-semibold text-blue-400 uppercase tracking-wider mb-2">Team</h2>
            <p className="text-3xl md:text-4xl font-bold text-white">Our Team</p>
          </div>
        </AnimatedSection>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8 mt-12">
          {teamMembers.map((member, index) => (
            <AnimatedCard key={index} index={index}>
              <TeamMember {...member} />
            </AnimatedCard>
          ))}
        </div>
      </div>
    </section>
  );
};

// Team Member Component
const TeamMember = ({ image, name, position }) => {
  return (
    <div className="dark-card rounded-xl overflow-hidden transition-all duration-300 relative z-10">
      <div className="relative overflow-hidden">
        <img 
          src={image} 
          alt={name} 
          className="w-full h-64 object-cover transition-transform duration-500 hover:scale-110" 
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-blue-900 to-transparent opacity-0 hover:opacity-70 transition-opacity duration-300"></div>
      </div>
      <div className="p-6 text-center bg-slate-800 bg-opacity-50">
        <h4 className="text-xl font-bold text-white mb-1 group-hover:text-blue-400 transition-colors">{name}</h4>
        <span className="text-blue-400 font-semibold">{position}</span>
      </div>
    </div>
  );
};

export default Team;